/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import Query from "../../../Basis/Queries/Query";
import Beleg from "./Beleg";

export interface LadeRechnungZuMandantInput {
    rechnungId: string;
}

export default class LadeRechnungZuMandant extends Query<Beleg, LadeRechnungZuMandantInput> {
    public static readonly queryName = "Mandanten_LadeRechnungZuMandant";

    private static readonly query = gql`
        query ${LadeRechnungZuMandant.queryName}($input: ${LadeRechnungZuMandant.queryName}) {
            ${LadeRechnungZuMandant.queryName}(input: $input) {
                id
                kundeId
                nummer
                art
                status
                datum
                betrag
                waehrung
                pdfUrl
                beginn
                ende
                konto
                steuercode
                mandant
                debitor
            }
        }
    `;

    public constructor(input: LadeRechnungZuMandantInput, onCompleted: (beleg: Beleg) => void) {
        super(LadeRechnungZuMandant.query, onCompleted, input);
    }

    public get name(): string {
        return LadeRechnungZuMandant.queryName;
    }
}